const COMPLETE_TIMED_OUT = 'COMPLETE_TIMED_OUT'

const messages = {
  [COMPLETE_TIMED_OUT]: 'Share took to long to complete.',
}

class FlowError extends Error {
  constructor(reason, originalError = undefined) {
    super()
    this.name = 'FlowError'
    this.message = messages[reason] || 'Sorry, there was a logic issue'
    this.reason = reason
    if (originalError) {
      this.message += `(details: ${originalError.message})`
    }
  }
}

FlowError.Reasons = {
  COMPLETE_TIMED_OUT
}

export default FlowError
